export const getNewImageUrlFromMealId = (id) => `_new-jars/1${id}.png`;
export const getNewImageUrlFromMealIdWithColor = (id, color_id) =>
  `_new-jars-color/1${id}-${color_id}.png`;
